(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RunnerRaceResumeDetailController', RunnerRaceResumeDetailController);

    RunnerRaceResumeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RunnerRaceResume', 'Runner', 'RacePositions', 'RaceResume'];

    function RunnerRaceResumeDetailController($scope, $rootScope, $stateParams, previousState, entity, RunnerRaceResume, Runner, RacePositions, RaceResume) {
        var vm = this;

        vm.runnerRaceResume = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:runnerRaceResumeUpdate', function(event, result) {
            vm.runnerRaceResume = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
